/**
 * “Volver” del panel Listas cuando se abrió desde otro panel. MapPage pasa
 * `onReturnToOrigin` + `returnOriginLabel` (mismo patrón que `listContextLabel`
 * del Dock):
 *
 * - Registros → lote CAD (`Registros`).
 * - Ficha de un lead → lista / lista CAD / lote CAD (`Lead: Ana`).
 *
 * Sin origen, todo queda como el flujo propio de Listas. La pila se respeta:
 * - Flecha de la cabecera en el detalle de una lista (fuera de “Agregar”) o en
 *   una lista CAD → al origen.
 * - Flecha del lote CAD abierto → al origen solo si el panel se abrió ya en ese
 *   lote (`openedAtCadParcel`); si el lote se eligió después dentro de la
 *   lista, vuelve a la lista (y desde ahí, al origen).
 *
 * @param {{
 *   hasOrigin: boolean,
 *   originLabel?: string,
 *   viewMode: string,
 *   addMode?: boolean,
 *   openedAtCadParcel?: boolean,
 *   cadListNameUpper?: string,
 * }} params
 * @returns {{
 *   headerToOrigin: boolean,
 *   headerBackTitle: string,
 *   cadParcelToOrigin: boolean,
 *   cadParcelBackTitle: string,
 *   cadParcelSubtitle: string,
 * }}
 */
export function resolveListsPanelReturnOrigin({
  hasOrigin,
  originLabel = '',
  viewMode,
  addMode = false,
  openedAtCadParcel = false,
  cadListNameUpper = '',
}) {
  const label = String(originLabel || '').trim() || 'Registros';
  const headerToOrigin = Boolean(hasOrigin)
    && (viewMode === 'cad' || (viewMode === 'detail' && !addMode));
  let headerBackTitle = 'Regresar a listas';
  if (headerToOrigin) headerBackTitle = `Volver a ${label}`;
  else if (viewMode === 'sharedDetail' || viewMode === 'cad') headerBackTitle = 'Volver a listas';

  const cadParcelToOrigin = Boolean(hasOrigin) && Boolean(openedAtCadParcel);
  const listContext = `Lista: ${cadListNameUpper}`;
  return {
    headerToOrigin,
    headerBackTitle,
    cadParcelToOrigin,
    cadParcelBackTitle: `Volver a ${cadParcelToOrigin ? label : listContext}`,
    cadParcelSubtitle: cadParcelToOrigin ? label : listContext,
  };
}
